function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  d: "M245.4,239.6c-13.4-0.3-26.1,4.7-35.7,14.1c-9.6,9.4-14.9,21.9-14.9,35.3c0,20.5,12.4,38.5,31.1,45.9v51.8 c0,31.6-27.6,57.2-61.6,57.2s-61.6-25.7-61.6-57.2v-5.9c18-4,34.3-13.8,46.3-27.9c13.1-15.4,20.3-34.9,20.3-55.1v-91.3 c0-5.5-3.8-10.2-9.1-11.4l-38.7-8.6c-6.3-1.3-12.6,2.7-13.9,8.9l-2.9,13c-1.3,6.3,2.7,12.6,8.9,13.9l19.1,4.2v70.6 c0,26.8-21.4,48.8-47.8,49c-0.2,0-0.4,0-0.6,0c-12.7,0-24.7-4.9-33.8-13.9c-9.2-9.1-14.3-21.3-14.3-34.3v-71.3l19.3-4.2 c3-0.6,5.6-2.5,7.3-5.1c1.6-2.6,2.2-5.7,1.5-8.8l-2.9-13c-0.7-3-2.5-5.6-5.1-7.3c-2.7-1.7-5.8-2.3-8.9-1.6l-38.8,8.6 c-5.3,1.2-9.1,6-9.1,11.4v91.3c0,20.1,7.3,39.7,20.3,55c12.1,14.1,28.4,23.9,46.3,27.9v5.9c0,51.7,44.1,93.8,98.2,93.8 c54.1,0,98.2-42.1,98.2-93.8v-51.8c18.6-7.4,30.9-25.2,31.1-45.5C293.8,262.5,272.2,240.2,245.4,239.6z M244.3,301.8 c-7.1,0-12.8-5.7-12.8-12.8s5.8-12.8,12.8-12.8c7.1,0,12.8,5.7,12.8,12.8S251.4,301.8,244.3,301.8z"
}), React.createElement("path", {
  d: "M445.4,119.5l-84.3-84.3c-6.6-6.6-18-1.9-18,7.4l0,63.3H10.1c-5.8,0-10.5,4.7-10.5,10.5v21c0,5.8,4.7,10.5,10.5,10.5h333.1 l0,63.3c0,9.3,11.3,14.1,18,7.4l84.3-84.3C449.5,130.3,449.5,123.6,445.4,119.5z"
}));

var SvgArrowStethoscope = function SvgArrowStethoscope(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 512",
    style: {
      enableBackground: "new 0 0 448 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowStethoscope, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-stethoscope.38a50a4f.svg";
export { ForwardRef as ReactComponent };